const personalData = {
    title: '',
    firstName: '',
    middleName: '',
    lastName: '',
    birth: '',
    ssn: '',
    confirmSsn: '',
    phone: '',
    maritalStatus: '',
    idenType: '',
    idenNumber: '',
    issueDate: '',
    expDate: '',
    permAddress: '',
    address2: '',
    city: '',
    country: '',
    zipCode: '',
    state: '',
    mailingCountry: '',
    mailingAddress: '',
    mailingAddress2: '',
    mailingCity: '',
    mailingZipCode: '',
    mailingState: '',
    trustName: '',
    trustCountry: '',
    isMailingAddressDifferent: false,
    mailingDiff: ''
};


const SET_PERSONAL_INFO = 'SET_PERSONAL_INFO'

export const setPersonalData = (personalData) => ({
    type: SET_PERSONAL_INFO,
    payload: personalData,
});

const personal_store = (state = personalData, action) => {
    switch (action.type) {
        case SET_PERSONAL_INFO:
            return {
                ...state,
                ...action.payload,
            }
        default:
            return state;
    }
};

export default personal_store;
